export const environment = {
  production: false,
  backendApi: 'https://roadaware-temp.neotreks.com/',
  issuer: 'https://roadaware-temp.neotreks.com',
  requireHttps: true,
  postLogoutRedirectUri: 'https://roadaware-temp.neotreks.com/account/signin',
  resetPasswordTemplateUrl: 'https://roadaware-temp.neotreks.com/account/reset-password?token={0}&user={1}',
};
